<template>
<div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center" v-show="imgLoaded">
    <div class="vx-col md:w-1/2 lg:w-6/12 xl:w-4/12 m-4">
        <vx-card>
            <div class="box mb-5">
                <span class="text">https://pedidorapido.app/<span class="text-danger">{{ url }}</span></span>
                <img @load="() => imageLoaded()" src="@/assets/images/pages/companySelector/SmartPhoneHelp.png" alt="coming-soon" class="mx-auto img-container">
            </div>
            
            <div class="subscription">
                <vs-input 
                    v-validate="{ required: true, min: 3, regex: /^[a-z0-9_]+$/ }"
                    name="Apresentacao"
                    v-model="url" 
                    color="danger" 
                    type="text" 
                    label="Nome de apresentação na URL" 
                    class="w-full"
                     @click="() => nickname == 'nome_da_minha_empresa' ? nickname = '' : ''" 
                />
                <div class="mt-2" v-show="errors.first('Apresentacao')">
                    <vx-tooltip title="Ajuda" text="Não é permitido espaços ou caracteres especiais, exceto: _ (subtraço)">
                        <span class="text-danger text-sm"> {{ errors.first('Apresentacao') }}</span>
                        <a-icon type="question-circle" class="ml-1" />
                    </vx-tooltip>
                </div>

                <vs-input 
                    v-validate="{ required: true }"
                    name="Nome Fantasia"
                    v-model="name" 
                    color="danger" 
                    type="text" 
                    label="Nome Fantasia"
                    placeholder="Ex.: Hamburgueria X-Tudo"
                    class="w-full mt-4"
                />
                <span class="text-danger text-sm"> {{ errors.first('Nome Fantasia') }}</span>
                
                <vs-button color="danger" class="w-full mt-4" @click="createCompany()">Criar a minha empresa!</vs-button>
                <vs-button @click="$router.push('/companySelect/')" type="line" color="warning" class="w-full mt-2">Voltar</vs-button>
            </div>
        </vx-card>
    </div>
</div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import basicFields from '@/components/company/basicFields.js'
    import { Validator } from 'vee-validate'

    export default {
        data () {
            return {
                ref : firebase.firestore(),
                imgLoaded : false,
                name : '',
                nickname : ''
            }
        },

        computed : {
            url : {
                get () {
                    return String(this.nickname).toLowerCase().slice(0, 22)
                },
                set (val) {
                    this.nickname = val.toLowerCase().replace(' ', '_')
                }
            }
        },

        methods : {
            async createCompany () {
                if(await this.$validator.validateAll()) {
                    try {
                        if (! await this.confirmToCreateCompany()) return 

                        this.$vs.loading()
                        let companyExists = await this.ref.collection('company').doc(this.nickname).get();
                        if(companyExists.exists) throw new Error('Já existe uma empresa com este nome de apresentação')

                        let user = this.$store.getters.getUserStoredData
                        user = {...user, ...{blocked : false, role: 0, main: true}}

                        let companyInfo = basicFields.getStartingInfoFields()
                        companyInfo.logo = await this.updateLogo()
                        companyInfo.fiscal.nomeFantasia = this.name
                        companyInfo.fiscal.numeroSequencia = 0
                        companyInfo.description = this.name;

                        var companyCollection = await this.ref.collection('company').doc(this.nickname).set(companyInfo)
                        await this.ref.collection('company').doc(this.nickname).collection('companyUsers').doc(user.id).set(user)

                        this.addFirstAdmUser();
                        this.addInitialCollections()

                        this.$store.dispatch('updateUserInfo', user)
                        this.$store.dispatch('updateCompanyInfo', companyInfo)
                        this.$store.dispatch('updateUserCompanyId', this.nickname)
                        this.$router.push('/dashboard/')
                    } catch(err) {
                        this.$vs.dialog({
                            type: 'alert',
                            title: 'Erro',
                            text: `Erro ao criar a empresa: ${err.message}`,
                            acceptText: 'Fechar'
                        })
                    } finally {
                        this.$vs.loading.close()
                    }
                }
            },

            async addFirstAdmUser () {
                let user = { ...this.$store.state.AppActiveUser };
                delete user.companyId; // AppActiveUser contains companyId and it cannot go to companyUsers!
                await this.ref.collection('company').doc(this.nickname).collection('companyUsers').doc(user.uid).set(user)
            },

            async addInitialCollections () {
                let menus = basicFields.getStartingMenus()
                for (let menu in menus) {
                    await this.ref.collection('company').doc(this.nickname).collection('menu').doc(menu).set(menus[menu])
                }

                let counters = basicFields.getStartingCounters()
                for (let counter in counters) {
                    await this.ref.collection('company').doc(this.nickname).collection('counters').doc(counter).set(counters[counter])
                }
            },

            updateLogo () {
                return new Promise(async (resolve) => {
                let storageRef = firebase.storage().ref().child(`companies/photos/no-photo.png`)
                let photoURL   = await storageRef.getDownloadURL()
                
                resolve(photoURL)
                })
            },

            confirmToCreateCompany () {
                return new Promise(resolve => {
                    this.$vs.dialog({
                        type: 'confirm',
                        title: 'Confirme a sua intenção',
                        text: 'Não será possível alterar o nome de apresentação da empresa posteriormente. Deseja realmente continuar?',
                        acceptText: 'Desejo continuar',
                        cancelText: 'Cancelar',
                        accept () {
                            resolve(true)
                        },
                        cancel () {
                            resolve(false)
                        }
                    })
                })
            },

            imageLoaded () {
                this.imgLoaded = true
                this.typeWrite('nome_da_minha_empresa')
            },

            typeWrite (text, currentText) {
                currentText = (currentText ? currentText : text)
                if(text != null)
                    setTimeout(() => {
                        this.nickname = this.nickname + currentText[0]
                        if(currentText.length == 1) return
                        currentText = currentText.slice(1, currentText.length)
                        this.typeWrite(text, currentText)
                    }, 110)
            }
        }
    }
</script>

<style scoped>
    .box{
        position: relative;
        display: inline-block; /* Make the width of box same as image */
    }

    .box .text{
        font-size: 12px;
        position: absolute;
        z-index: 999;
        margin: 0 auto;
        left: 15%;
        right: 0%;
        top: 55.4%; /* Adjust this value to move the positioned div up and down */
        text-align: left;
        width: 100%; /* Set the width of the positioned div */
    }

    .box .img-container {
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
    }
</style>